export default __webpack_public_path__ + "static/media/funnel.bf96d2e4.svg";